var iconsAlternative = {
  ic_bill: {
    l: "ic_bill_l",
    s: "ic_bill_s"
  },
  "ic_discount-out": {
    l: "ic_discount-out-l"
  },
  "ic_cargo-out": {
    l: "ic_cargo-out-l",
    m: "ic_cargo-out-m"
  },
  "ic_filter-out": {
    l: "ic_filter-out-l",
    m: "ic_filter-out-m"
  },
  "ic_truck-out": {
    xl: "ic_truck-out-l",
    l: "ic_truck-out-l",
    m: "ic_truck-out-m",
    s: "ic_truck-out-s"
  },
  "ic_del-out": {
    xl: "ic_del-out-l",
    l: "ic_del-out-l",
    m: "ic_del-out-m",
    s: "ic_del-out-s"
  },
  "ic_schedule-out": {
    xl: "ic_schedule-out-l",
    l: "ic_schedule-out-l",
    m: "ic_schedule-out-m",
    s: "ic_schedule-out-s"
  },
  "ic_orders-from-you-out-down": {
    xl: "ic_orders-from-you-out-down-l",
    l: "ic_orders-from-you-out-down-l",
    m: "ic_orders-from-you-out-down-m",
    s: "ic_orders-from-you-out-down-s"
  },
  "ic_orders-to-you-out-down": {
    xl: "ic_orders-to-you-out-down-l",
    l: "ic_orders-to-you-out-down-l",
    m: "ic_orders-to-you-out-down-m",
    s: "ic_orders-to-you-out-down-s"
  },
  "ic_orders-from-you-out": {
    xl: "ic_orders-from-you-out-l",
    l: "ic_orders-from-you-out-l",
    m: "ic_orders-from-you-out-m",
    s: "ic_orders-from-you-out-s"
  },
  "ic_orders-to-you-out": {
    xl: "ic_orders-to-you-out-l",
    l: "ic_orders-to-you-out-l",
    m: "ic_orders-to-you-out-m",
    s: "ic_orders-to-you-out-s"
  },
  "ic_mini-arrow": {
    xl: "ic_mini-arrow-l",
    l: "ic_mini-arrow-l",
    m: "ic_mini-arrow-m",
    s: "ic_mini-arrow-s"
  },
  "ic_arrow-left-out": {
    xl: "ic_arrow-left-out-l",
    l: "ic_arrow-left-out-l",
    m: "ic_arrow-left-out-m",
    s: "ic_arrow-left-out-s"
  },
  "ic_chart-out": {
    xl: "ic_chart-out-l",
    l: "ic_chart-out-l",
    m: "ic_chart-out-m",
    s: "ic_chart-out-s"
  },
  "ic_location-out": {
    xl: "ic_location-out-l",
    l: "ic_location-out-l",
    m: "ic_location-out-m",
    s: "ic_location-out-s"
  },
  "ic_search-out": {
    xl: "ic_search-out-l",
    l: "ic_search-out-l",
    m: "ic_search-out-m",
    s: "ic_search-out-s"
  },
  "ic_refresh-out": {
    xl: "ic_refresh-out-l",
    l: "ic_refresh-out-l",
    m: "ic_refresh-out-m",
    s: "ic_refresh-out-s"
  },
  "ic_edit-out": {
    xl: "ic_edit-out-l",
    l: "ic_edit-out-l",
    m: "ic_edit-out-m",
    s: "ic_edit-out-s"
  },
  "ic_copy-out": {
    xl: "ic_copy-out-l",
    l: "ic_copy-out-l",
    m: "ic_copy-out-m",
    s: "ic_copy-out-s"
  },
  "ic_saved-search-out": {
    xl: "ic_saved-search-out-l",
    l: "ic_saved-search-out-l",
    m: "ic_saved-search-out-m",
    s: "ic_saved-search-out-s"
  },
  "ic_history-out": {
    xl: "ic_history-out-l",
    l: "ic_history-out-l",
    m: "ic_history-out-m",
    s: "ic_history-out-s"
  },
  "ic_close-out": {
    xl: "ic_close-out-l",
    l: "ic_close-out-l",
    m: "ic_close-out-m",
    s: "ic_close-out-s"
  },
  "ic_star-out": {
    xl: "ic_star-out-xl",
    l: "ic_star-out-l",
    m: "ic_star-out-m",
    s: "ic_star-out-s"
  },
  "ic_star-filled-out": {
    xl: "ic_star-filled-out-xl",
    l: "ic_star-filled-out-l",
    m: "ic_star-filled-out-m",
    s: "ic_star-filled-out-s"
  },
  "ic_lot-disunion": {
    xl: "ic_lot-disunion-l",
    l: "ic_lot-disunion-l",
    m: "ic_lot-disunion-m",
    s: "ic_lot-disunion-s"
  },
  "ic_eye-out": {
    xl: "ic_eye-out-l",
    l: "ic_eye-out-l",
    m: "ic_eye-out-m",
    s: "ic_eye-out-s"
  },
  "ic_arrow-up-out": {
    xl: "ic_arrow-up-out-l",
    l: "ic_arrow-up-out-l",
    m: "ic_arrow-up-out-m",
    s: "ic_arrow-up-out-s"
  },
  "ic_check-out": {
    xl: "ic_check-out-l",
    l: "ic_check-out-l",
    m: "ic_check-out-m",
    s: "ic_check-out-s"
  },
  "ic_empty-out": {
    xl: "ic_empty-out-l",
    l: "ic_empty-out-l",
    m: "ic_empty-out-m",
    s: "ic_empty-out-s"
  },
  "ic_eye-closed-out": {
    xl: "ic_eye-closed-out-l",
    l: "ic_eye-closed-out-l",
    m: "ic_eye-closed-out-m",
    s: "ic_eye-closed-out-s"
  },
  "ic_arrow-right-out": {
    xl: "ic_arrow-right-out-l",
    l: "ic_arrow-right-out-l",
    m: "ic_arrow-right-out-m",
    s: "ic_arrow-right-out-s"
  },
  "ic_round-check-out": {
    xl: "ic_round-check-out-l",
    l: "ic_round-check-out-l",
    m: "ic_round-check-out-m",
    s: "ic_round-check-out-s"
  },
  "ic_arrow-down-out": {
    xl: "ic_arrow-down-out-l",
    l: "ic_arrow-down-out-l",
    m: "ic_arrow-down-out-m",
    s: "ic_arrow-down-out-s"
  },
  "ic_lens-out": {
    xl: "ic_lens-out-l",
    l: "ic_lens-out-l",
    m: "ic_lens-out-m",
    s: "ic_lens-out-s"
  },
  "ic_alert-out": {
    xl: "ic_alert-out-l",
    l: "ic_alert-out-l",
    m: "ic_alert-out-m",
    s: "ic_alert-out-s"
  },
  "ic_archive-out": {
    xl: "ic_archive-out-l",
    l: "ic_archive-out-l",
    m: "ic_archive-out-m",
    s: "ic_archive-out-s"
  },
  "ic_computer-out": {
    xl: "ic_computer-out-l",
    l: "ic_computer-out-l",
    m: "ic_computer-out-m",
    s: "ic_computer-out-s"
  },
  "ic_orders-out": {
    xl: "ic_orders-out-l",
    l: "ic_orders-out-l",
    m: "ic_orders-out-m",
    s: "ic_orders-out-s"
  },
  "ic_dock-filled-out": {
    xl: "ic_dock-filled-out-l",
    l: "ic_dock-filled-out-l",
    m: "ic_dock-filled-out-m",
    s: "ic_dock-filled-out-s"
  },
  "ic_active-session-out": {
    xl: "ic_active-session-out-l",
    l: "ic_active-session-out-l",
    m: "ic_active-session-out-m",
    s: "ic_active-session-out-s"
  },
  "ic_notification-message-out": {
    xl: "ic_notification-message-out-l",
    l: "ic_notification-message-out-l",
    m: "ic_notification-message-out-m",
    s: "ic_notification-message-out-s"
  },
  "ic_scan-out": {
    xl: "ic_scan-out-l",
    l: "ic_scan-out-l",
    m: "ic_scan-out-m",
    s: "ic_scan-out-s"
  },
  "ic_calc-out": {
    xl: "ic_calc-out-l",
    l: "ic_calc-out-l",
    m: "ic_calc-out-m",
    s: "ic_calc-out-s"
  },
  "ic_flag-out": {
    xl: "ic_flag-out-l",
    l: "ic_flag-out-l",
    m: "ic_flag-out-m",
    s: "ic_flag-out-s"
  },
  "ic_income-out": {
    xl: "ic_income-out-l",
    l: "ic_income-out-l",
    m: "ic_income-out-m",
    s: "ic_income-out-s"
  },
  "ic_outgoing-out": {
    xl: "ic_outgoing-out-l",
    l: "ic_outgoing-out-l",
    m: "ic_outgoing-out-m",
    s: "ic_outgoing-out-s"
  },
  "ic_clock-out": {
    xl: "ic_clock-out-l",
    l: "ic_clock-out-l",
    m: "ic_clock-out-m",
    s: "ic_clock-out-s"
  },
  "ic_draft-out": {
    xl: "ic_draft-out-l",
    l: "ic_draft-out-l",
    m: "ic_draft-out-m",
    s: "ic_draft-out-s"
  },
  "ic_user-out": {
    xl: "ic_user-out-l",
    l: "ic_user-out-l",
    m: "ic_user-out-m",
    s: "ic_user-out-s"
  },
  "ic_mobile-out": {
    xl: "ic_mobile-out-l",
    l: "ic_mobile-out-l",
    m: "ic_mobile-out-m",
    s: "ic_mobile-out-s"
  },
  "ic_shield-out": {
    xl: "ic_shield-out-l",
    l: "ic_shield-out-l",
    m: "ic_shield-out-m",
    s: "ic_shield-out-s"
  },
  "ic_burger-out": {
    xl: "ic_burger-out-l",
    l: "ic_burger-out-l",
    m: "ic_burger-out-m",
    s: "ic_burger-out-s"
  },
  "ic_add-out": {
    xl: "ic_add-out-l",
    l: "ic_add-out-l",
    m: "ic_add-out-m",
    s: "ic_add-out-s"
  },
  "ic_mobile-devices-out": {
    xl: "ic_mobile-devices-out-l",
    l: "ic_mobile-devices-out-l",
    m: "ic_mobile-devices-out-m",
    s: "ic_mobile-devices-out-s"
  },
  "ic_rouble-out": {
    xl: "ic_rouble-out-l",
    l: "ic_rouble-out-l",
    m: "ic_rouble-out-m",
    s: "ic_rouble-out-s"
  },
  "ic_route-out": {
    xl: "ic_route-out-l",
    l: "ic_route-out-l",
    m: "ic_route-out-m",
    s: "ic_route-out-s"
  },
  "ic_exit-in": {
    xl: "ic_exit-in-l",
    l: "ic_exit-in-l",
    m: "ic_exit-in-m",
    s: "ic_exit-in-s"
  },
  "ic_exit-out": {
    xl: "ic_exit-out-l",
    l: "ic_exit-out-l",
    m: "ic_exit-out-m",
    s: "ic_exit-out-s"
  },
  "ic_count-out": {
    xl: "ic_count-out-l",
    l: "ic_count-out-l",
    m: "ic_count-out-m",
    s: "ic_count-out-s"
  },
  "ic_coin-out": {
    xl: "ic_coin-out-l",
    l: "ic_coin-out-l",
    m: "ic_coin-out-m",
    s: "ic_coin-out-s"
  },
  "ic_car-rent-out": {
    xl: "ic_car-rent-out-l",
    l: "ic_car-rent-out-l",
    m: "ic_car-rent-out-m",
    s: "ic_car-rent-out-s"
  },
  "ic_truck-buy-out": {
    xl: "ic_truck-buy-out-l",
    l: "ic_truck-buy-out-l",
    m: "ic_truck-buy-out-m",
    s: "ic_truck-buy-out-s"
  },
  "ic_order-buy-out": {
    xl: "ic_order-buy-out-l",
    l: "ic_order-buy-out-l",
    m: "ic_order-buy-out-m",
    s: "ic_order-buy-out-s"
  },
  "ic_order-rent-out": {
    xl: "ic_order-rent-out-l",
    l: "ic_order-rent-out-l",
    m: "ic_order-rent-out-m",
    s: "ic_order-rent-out-s"
  },
  "ic_ads-out": {
    xl: "ic_ads-out-l",
    l: "ic_ads-out-l",
    m: "ic_ads-out-m",
    s: "ic_ads-out-s"
  },
  "ic_wallet-out": {
    xl: "ic_wallet-out-l",
    l: "ic_wallet-out-l",
    m: "ic_wallet-out-m",
    s: "ic_wallet-out-s"
  },
  "ic_hands-out": {
    xl: "ic_hands-out-l",
    l: "ic_hands-out-l",
    m: "ic_hands-out-m",
    s: "ic_hands-out-s"
  },
  "ic_banknote-out": {
    xl: "ic_banknote-out-l",
    l: "ic_banknote-out-l",
    m: "ic_banknote-out-m",
    s: "ic_banknote-out-s"
  },
  "ic_card-out": {
    xl: "ic_card-out-l",
    l: "ic_card-out-l",
    m: "ic_card-out-m",
    s: "ic_card-out-s"
  },
  "ic_mail-2-out": {
    xl: "ic_mail-2-out-l",
    l: "ic_mail-2-out-l",
    m: "ic_mail-2-out-m",
    s: "ic_mail-2-out-s"
  },
  "ic_my-board-out": {
    xl: "ic_my-board-out-l",
    l: "ic_my-board-out-l",
    m: "ic_my-board-out-m",
    s: "ic_my-board-out-s"
  },
  "ic_open-board-out": {
    xl: "ic_open-board-out-l",
    l: "ic_open-board-out-l",
    m: "ic_open-board-out-m",
    s: "ic_open-board-out-s"
  },
  "ic_copy-board-out": {
    xl: "ic_copy-board-out-l",
    l: "ic_copy-board-out-l",
    m: "ic_copy-board-out-m",
    s: "ic_copy-board-out-s"
  },
  "ic_tender-out": {
    xl: "ic_tender-out-l",
    l: "ic_tender-out-l",
    m: "ic_tender-out-m",
    s: "ic_tender-out-s"
  },
  "ic_part-board-out": {
    xl: "ic_part-board-out-l",
    l: "ic_part-board-out-l",
    m: "ic_part-board-out-m",
    s: "ic_part-board-out-s"
  },
  "ic_phone-out": {
    xl: "ic_phone-out-l",
    l: "ic_phone-out-l",
    m: "ic_phone-out-m",
    s: "ic_phone-out-s"
  },
  ic_hryvnia: {
    xl: "ic_hryvnia-l",
    l: "ic_hryvnia-l",
    m: "ic_hryvnia-m",
    s: "ic_hryvnia-s"
  },
  ic_lari: {
    xl: "ic_lari-l",
    l: "ic_lari-l",
    m: "ic_lari-m",
    s: "ic_lari-s"
  },
  ic_rouble: {
    xl: "ic_rouble-l",
    l: "ic_rouble-l",
    m: "ic_rouble-m",
    s: "ic_rouble-s"
  },
  ic_dram: {
    xl: "ic_dram-l",
    l: "ic_dram-l",
    m: "ic_dram-m",
    s: "ic_dram-s"
  },
  ic_euro: {
    xl: "ic_euro-l",
    l: "ic_euro-l",
    m: "ic_euro-m",
    s: "ic_euro-s"
  },
  ic_tenge: {
    xl: "ic_tenge-l",
    l: "ic_tenge-l",
    m: "ic_tenge-m",
    s: "ic_tenge-s"
  },
  ic_dollar: {
    xl: "ic_dollar-l",
    l: "ic_dollar-l",
    m: "ic_dollar-m",
    s: "ic_dollar-s"
  },
  ic_som: {
    xl: "ic_som-l",
    l: "ic_som-l",
    m: "ic_som-m",
    s: "ic_som-s"
  },
  ic_atis: {
    xl: "ic_atis-l",
    l: "ic_atis-l",
    m: "ic_atis-m",
    s: "ic_atis-s"
  },
  "ic_loadowner-city-other": {
    xl: "ic_loadowner-city-other-xl",
    l: "ic_loadowner-city-other-l",
    m: "ic_loadowner-city-other-m",
    s: "ic_loadowner-city-other-s"
  },
  "ic_loadowner-city-first": {
    xl: "ic_loadowner-city-first-xl",
    l: "ic_loadowner-city-first-l",
    m: "ic_loadowner-city-first-m",
    s: "ic_loadowner-city-first-s"
  },
  "ic_loadowner-city-second": {
    xl: "ic_loadowner-city-second-xl",
    l: "ic_loadowner-city-second-l",
    m: "ic_loadowner-city-second-m",
    s: "ic_loadowner-city-second-s"
  },
  "ic_loadowner-city-third": {
    xl: "ic_loadowner-city-third-xl",
    l: "ic_loadowner-city-third-l",
    m: "ic_loadowner-city-third-m",
    s: "ic_loadowner-city-third-s"
  },
  "ic_dispatcher-city-second": {
    xl: "ic_dispatcher-city-second-xl",
    l: "ic_dispatcher-city-second-l",
    m: "ic_dispatcher-city-second-m",
    s: "ic_dispatcher-city-second-s"
  },
  "ic_loadowner-country-third": {
    xl: "ic_loadowner-country-third-xl",
    l: "ic_loadowner-country-third-l",
    m: "ic_loadowner-country-third-m",
    s: "ic_loadowner-country-third-s"
  },
  "ic_loadowner-country-second": {
    xl: "ic_loadowner-country-second-xl",
    l: "ic_loadowner-country-second-l",
    m: "ic_loadowner-country-second-m",
    s: "ic_loadowner-country-second-s"
  },
  "ic_loadowner-country-first": {
    xl: "ic_loadowner-country-first-xl",
    l: "ic_loadowner-country-first-l",
    m: "ic_loadowner-country-first-m",
    s: "ic_loadowner-country-first-s"
  },
  "ic_loadowner-country-other": {
    xl: "ic_loadowner-country-other-xl",
    l: "ic_loadowner-country-other-l",
    m: "ic_loadowner-country-other-m",
    s: "ic_loadowner-country-other-s"
  },
  "ic_winner-badge-2": {
    xl: "ic_winner-badge-2-xl",
    l: "ic_winner-badge-2-l",
    m: "ic_winner-badge-2-m",
    s: "ic_winner-badge-2-s"
  },
  "ic_cup-3": {
    xl: "ic_cup-3-xl",
    l: "ic_cup-3-l",
    m: "ic_cup-3-m",
    s: "ic_cup-3-s"
  },
  "ic_cup-2": {
    xl: "ic_cup-2-xl",
    l: "ic_cup-2-l",
    m: "ic_cup-2-m",
    s: "ic_cup-2-s"
  },
  "ic_ribbon-3": {
    xl: "ic_ribbon-3-xl",
    l: "ic_ribbon-3-l",
    m: "ic_ribbon-3-m",
    s: "ic_ribbon-3-s"
  },
  "ic_ribbon-2": {
    xl: "ic_ribbon-2-xl",
    l: "ic_ribbon-2-l",
    m: "ic_ribbon-2-m",
    s: "ic_ribbon-2-s"
  },
  "ic_warehouse-out": {
    xl: "ic_warehouse-out-l",
    l: "ic_warehouse-out-l",
    m: "ic_warehouse-out-m",
    s: "ic_warehouse-out-s"
  },
  "ic_warehouse-count-out": {
    xl: "ic_warehouse-count-out-l",
    l: "ic_warehouse-count-out-l",
    m: "ic_warehouse-count-out-m",
    s: "ic_warehouse-count-out-s"
  },
  "ic_warehouse-out-down": {
    xl: "ic_warehouse-out-down-l",
    l: "ic_warehouse-out-down-l",
    m: "ic_warehouse-out-down-m",
    s: "ic_warehouse-out-down-s"
  },
  "ic_warehouse-count-out-down": {
    xl: "ic_warehouse-count-out-down-l",
    l: "ic_warehouse-count-out-down-l",
    m: "ic_warehouse-count-out-down-m",
    s: "ic_warehouse-count-out-down-s"
  },
  "ic_invite-board-out": {
    xl: "ic_invite-board-out-l",
    l: "ic_invite-board-out-l",
    m: "ic_invite-board-out-m",
    s: "ic_invite-board-out-s"
  },
  "ic_invite-board-out-down": {
    xl: "ic_invite-board-out-down-l",
    l: "ic_invite-board-out-down-l",
    m: "ic_invite-board-out-down-m",
    s: "ic_invite-board-out-down-s"
  },
  "ic_booking-out": {
    xl: "ic_booking-out-l",
    l: "ic_booking-out-l",
    m: "ic_booking-out-m",
    s: "ic_booking-out-s"
  },
  "ic_booking-out-down": {
    xl: "ic_booking-out-down-l",
    l: "ic_booking-out-down-l",
    m: "ic_booking-out-down-m",
    s: "ic_booking-out-down-s"
  },
  "ic_lot-union-out": {
    xl: "ic_lot-union-out-l",
    l: "ic_lot-union-out-l",
    m: "ic_lot-union-out-m",
    s: "ic_lot-union-out-s"
  },
  "ic_winner-badge-3": {
    xl: "ic_winner-badge-3-xl",
    l: "ic_winner-badge-3-l",
    m: "ic_winner-badge-3-m",
    s: "ic_winner-badge-3-s"
  },
  "ic_ribbon-star": {
    xl: "ic_ribbon-star-xl",
    l: "ic_ribbon-star-l",
    m: "ic_ribbon-star-m",
    s: "ic_ribbon-star-s"
  },
  "ic_traffic-light": {
    xl: "ic_traffic-light-xl",
    l: "ic_traffic-light-l",
    m: "ic_traffic-light-m",
    s: "ic_traffic-light-s"
  },
  "ic_traffic-white": {
    xl: "ic_traffic-white-xl",
    l: "ic_traffic-white-l",
    m: "ic_traffic-white-m",
    s: "ic_traffic-white-s"
  },
  "ic_winner-badge-disabled": {
    xl: "ic_winner-badge-disabled-xl",
    l: "ic_winner-badge-disabled-l",
    m: "ic_winner-badge-disabled-m",
    s: "ic_winner-badge-disabled-s"
  },
  "ic_services-filled": {
    xl: "ic_services-filled-l",
    l: "ic_services-filled-l",
    m: "ic_services-filled-m",
    s: "ic_services-filled-s"
  },
  "ic_services-out": {
    xl: "ic_services-out-l",
    l: "ic_services-out-l",
    m: "ic_services-out-m",
    s: "ic_services-out-s"
  },
  "ic_services-out-down": {
    xl: "ic_services-out-down-l",
    l: "ic_services-out-down-l",
    m: "ic_services-out-down-m",
    s: "ic_services-out-down-s"
  },
  "ic_question-outline": {
    xl: "ic_question-outline-l",
    l: "ic_question-outline-l",
    m: "ic_question-outline-m",
    s: "ic_question-outline-s"
  },
  "ic_arrows-down-out": {
    xl: "ic_arrows-down-out-l",
    l: "ic_arrows-down-out-l",
    m: "ic_arrows-down-out-m",
    s: "ic_arrows-down-out-s"
  },
  "ic_arrows-up-out": {
    xl: "ic_arrows-up-out-l",
    l: "ic_arrows-up-out-l",
    m: "ic_arrows-up-out-m",
    s: "ic_arrows-up-out-s"
  },
  "ic_setting-out": {
    xl: "ic_setting-out-l",
    l: "ic_setting-out-l",
    m: "ic_setting-out-m",
    s: "ic_setting-out-s"
  },
  "ic_plus-out": {
    xl: "ic_plus-out-l",
    l: "ic_plus-out-l",
    m: "ic_plus-out-m",
    s: "ic_plus-out-s"
  },
  "ic_minus-out": {
    xl: "ic_minus-out-l",
    l: "ic_minus-out-l",
    m: "ic_minus-out-m",
    s: "ic_minus-out-s"
  },
  "ic_ati-docs-colorless": {
    xl: "ic_ati-docs-colorless-l",
    l: "ic_ati-docs-colorless-l",
    m: "ic_ati-docs-colorless-m",
    s: "ic_ati-docs-colorless-s"
  },
  ic_visa: {
    xl: "ic_visa-l",
    l: "ic_visa-l",
    m: "ic_visa-m",
    s: "ic_visa-s"
  },
  "ic_visa-white": {
    xl: "ic_visa-white-l",
    l: "ic_visa-white-l",
    m: "ic_visa-white-m",
    s: "ic_visa-white-s"
  },
  "ic_lightning-filled": {
    xl: "ic_lightning-filled-l",
    l: "ic_lightning-filled-l",
    m: "ic_lightning-filled-m",
    s: "ic_lightning-filled-s"
  },
  "ic_api-ati": {
    xl: "ic_api-ati-l",
    l: "ic_api-ati-l",
    m: "ic_api-ati-m",
    s: "ic_api-ati-s"
  },
  "ic_academy-ati": {
    xl: "ic_academy-ati-l",
    l: "ic_academy-ati-l",
    m: "ic_academy-ati-m",
    s: "ic_academy-ati-s"
  },
  "ic_index-ati": {
    xl: "ic_index-ati-l",
    l: "ic_index-ati-l",
    m: "ic_index-ati-m",
    s: "ic_index-ati-s"
  },
  "ic_goga-ati": {
    xl: "ic_goga-ati-l",
    l: "ic_goga-ati-l",
    m: "ic_goga-ati-m",
    s: "ic_goga-ati-s"
  },
  "ic_forums-ati": {
    xl: "ic_forums-ati-l",
    l: "ic_forums-ati-l",
    m: "ic_forums-ati-m",
    s: "ic_forums-ati-s"
  },
  "ic_gps-ati": {
    xl: "ic_gps-ati-l",
    l: "ic_gps-ati-l",
    m: "ic_gps-ati-m",
    s: "ic_gps-ati-s"
  },
  "ic_news-ati": {
    xl: "ic_news-ati-l",
    l: "ic_news-ati-l",
    m: "ic_news-ati-m",
    s: "ic_news-ati-s"
  },
  "ic_average-rates-ati": {
    xl: "ic_average-rates-ati-l",
    l: "ic_average-rates-ati-l",
    m: "ic_average-rates-ati-m",
    s: "ic_average-rates-ati-s"
  },
  "ic_bidding-ati": {
    xl: "ic_bidding-ati-l",
    l: "ic_bidding-ati-l",
    m: "ic_bidding-ati-m",
    s: "ic_bidding-ati-s"
  },
  "ic_active-carriers-ati": {
    xl: "ic_active-carriers-ati-l",
    l: "ic_active-carriers-ati-l",
    m: "ic_active-carriers-ati-m",
    s: "ic_active-carriers-ati-s"
  },
  "ic_referral-program-ati": {
    xl: "ic_referral-program-ati-l",
    l: "ic_referral-program-ati-l",
    m: "ic_referral-program-ati-m",
    s: "ic_referral-program-ati-s"
  },
  "ic_unlimited-verification-ati": {
    xl: "ic_unlimited-verification-ati-l",
    l: "ic_unlimited-verification-ati-l",
    m: "ic_unlimited-verification-ati-m",
    s: "ic_unlimited-verification-ati-s"
  },
  "ic_orders-ati": {
    xl: "ic_orders-ati-l",
    l: "ic_orders-ati-l",
    m: "ic_orders-ati-m",
    s: "ic_orders-ati-s"
  },
  "ic_distance-calculation-ati": {
    xl: "ic_distance-calculation-ati-l",
    l: "ic_distance-calculation-ati-l",
    m: "ic_distance-calculation-ati-m",
    s: "ic_distance-calculation-ati-s"
  },
  "ic_rating-ati": {
    xl: "ic_rating-ati-l",
    l: "ic_rating-ati-l",
    m: "ic_rating-ati-m",
    s: "ic_rating-ati-s"
  },
  "ic_checks-ati": {
    xl: "ic_checks-ati-l",
    l: "ic_checks-ati-l",
    m: "ic_checks-ati-m",
    s: "ic_checks-ati-s"
  },
  "ic_boards-ati": {
    xl: "ic_boards-ati-l",
    l: "ic_boards-ati-l",
    m: "ic_boards-ati-m",
    s: "ic_boards-ati-s"
  },
  "ic_insurance-ati": {
    xl: "ic_insurance-ati-l",
    l: "ic_insurance-ati-l",
    m: "ic_insurance-ati-m",
    s: "ic_insurance-ati-s"
  },
  "ic_chains-ati": {
    xl: "ic_chains-ati-l",
    l: "ic_chains-ati-l",
    m: "ic_chains-ati-m",
    s: "ic_chains-ati-s"
  },
  "ic_traffic-ati": {
    xl: "ic_traffic-ati-l",
    l: "ic_traffic-ati-l",
    m: "ic_traffic-ati-m",
    s: "ic_traffic-ati-s"
  },
  "ic_tenders-ati": {
    xl: "ic_tenders-ati-l",
    l: "ic_tenders-ati-l",
    m: "ic_tenders-ati-m",
    s: "ic_tenders-ati-s"
  },
  "ic_billing-ati": {
    xl: "ic_billing-ati-l",
    l: "ic_billing-ati-l",
    m: "ic_billing-ati-m",
    s: "ic_billing-ati-s"
  },
  "ic_special-offers-ati": {
    xl: "ic_special-offers-ati-l",
    l: "ic_special-offers-ati-l",
    m: "ic_special-offers-ati-m",
    s: "ic_special-offers-ati-s"
  },
  "ic_timeslots-ati": {
    xl: "ic_timeslots-ati-l",
    l: "ic_timeslots-ati-l",
    m: "ic_timeslots-ati-m",
    s: "ic_timeslots-ati-s"
  },
  "ic_catalogs-ati": {
    xl: "ic_catalogs-ati-l",
    l: "ic_catalogs-ati-l",
    m: "ic_catalogs-ati-m",
    s: "ic_catalogs-ati-s"
  },
  "ic_tickets-ati": {
    xl: "ic_tickets-ati-l",
    l: "ic_tickets-ati-l",
    m: "ic_tickets-ati-m",
    s: "ic_tickets-ati-s"
  },
  "ic_profitable-destinations-ati": {
    xl: "ic_profitable-destinations-ati-l",
    l: "ic_profitable-destinations-ati-l",
    m: "ic_profitable-destinations-ati-m",
    s: "ic_profitable-destinations-ati-s"
  },
  "ic_partners-out": {
    xl: "ic_partners-out-l",
    l: "ic_partners-out-l",
    m: "ic_partners-out-m",
    s: "ic_partners-out-s"
  },
  "ic_busyness-out": {
    xl: "ic_busyness-out-l",
    l: "ic_busyness-out-l",
    m: "ic_busyness-out-m",
    s: "ic_busyness-out-s"
  },
  ic_rutube: {
    xl: "ic_rutube-l",
    l: "ic_rutube-l",
    m: "ic_rutube-m",
    s: "ic_rutube-s"
  },
  "ic_garage-out": {
    xl: "ic_garage-out-l",
    l: "ic_garage-out-l",
    m: "ic_garage-out-m",
    s: "ic_garage-out-s"
  },
  "ic_office-building-out": {
    xl: "ic_office-building-out-l",
    l: "ic_office-building-out-l",
    m: "ic_office-building-out-m",
    s: "ic_office-building-out-s"
  },
  "ic_clipboard-text-out": {
    xl: "ic_clipboard-text-out-l",
    l: "ic_clipboard-text-out-l",
    m: "ic_clipboard-text-out-m",
    s: "ic_clipboard-text-out-s"
  },
  "ic_like-list-out": {
    xl: "ic_like-list-out-l",
    l: "ic_like-list-out-l",
    m: "ic_like-list-out-m",
    s: "ic_like-list-out-s"
  },
  "ic_globe-pin-out": {
    xl: "ic_globe-pin-out-l",
    l: "ic_globe-pin-out-l",
    m: "ic_globe-pin-out-m",
    s: "ic_globe-pin-out-s"
  },
  "ic_link-out": {
    xl: "ic_link-out-l",
    l: "ic_link-out-l",
    m: "ic_link-out-m",
    s: "ic_link-out-s"
  }
};
var defaultSizes = {
  xl: [32, 32],
  l: [28, 28],
  m: [20, 20],
  s: [14, 14]
};
export { iconsAlternative, defaultSizes };